import { queryFormat } from '../../../helpers'

function requestAPI(queryString, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}review-product?${queryString}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionListReviewProduct(page, limit, search, startDate, endDate, star, isShow) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'LIST_REVIEW_PRODUCT_BEGIN'
    })

    try {
      const queryString = await queryFormat({ 
        page: page, 
        limit: limit, 
        search: search, 
        start_date: (startDate) ? startDate : '',
        end_date: (endDate) ? endDate : '',
        star: (star) ? star : '',
        is_show: (isShow !== undefined && isShow !== null && isShow !== '') ? isShow : undefined
      })
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(queryString, token)
      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_REVIEW_PRODUCT_SUCCESS',
        page: result.data.page,
        pages: result.data.pages,
        limit: result.data.limit,
        stars: result.data.stars,
        payload: result.data.reviews
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'LIST_REVIEW_PRODUCT_FAILURE',        
    error: error    
  })
}
